export const iconFontAwesomeMedicalHealthBacterium = (
	<i className="fa-solid fa-bacterium"></i>
);
